import React from "react"
const WaypointContext = React.createContext(null)
export default WaypointContext
